import gql from "graphql-tag";
export default gql`
  mutation($id: String!) {
    deleteFont(id: $id)
  }
`;
